import { render, staticRenderFns } from "./send-messages.vue?vue&type=template&id=7742da8e&scoped=true&"
import script from "./send-messages.vue?vue&type=script&lang=js&"
export * from "./send-messages.vue?vue&type=script&lang=js&"
import style0 from "./send-messages.vue?vue&type=style&index=0&id=7742da8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7742da8e",
  null
  
)

component.options.__file = "send-messages.vue"
export default component.exports